module.exports = __webpack_public_path__ + "static/img/unit-4.288fbe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/unit-4.png
// module id = i7U+
// module chunks = 51